import styled from '@emotion/styled';

import { customPalette } from '../../styles/theme';

export const Header = styled.h1`
  color: ${customPalette.grey[800]};
  font-size: 32px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 24px;
  border-bottom: none;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
}`;

export const Section = styled.div``;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.15px;
  margin-bottom: 14px;
  color: ${customPalette.accent.main};
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  & > div {
    flex: 1 1 calc(50% - 16px);
    max-width: calc(50% - 16px);
    box-sizing: border-box;

    @media (max-width: 1200px) {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
`;

export const FieldsContainer = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
`;

export const AddressWrapper = styled(FlexContainer)``;

export const MasterdataWrapper = styled(FlexContainer)``;

export const DataRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
}`;
